// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var communityRouter = {
  path: '/community',
  component: Layout,
  redirect: '/community/topics',
  name: 'Community',
  meta: {
    title: '用户',
    icon: 'clipboard'
  },
  children: [{
    path: 'topics',
    name: 'communityTopics',
    component: function component() {
      return import('@/views/community/topics/index');
    },
    meta: {
      title: '社区话题',
      icon: 'clipboard'
    }
  }, {
    path: 'classification',
    name: 'communityClassification',
    component: function component() {
      return import('@/views/community/classification/index');
    },
    meta: {
      title: '社区分类',
      icon: 'clipboard'
    }
  }, {
    path: 'content',
    name: 'communityContent',
    component: function component() {
      return import('@/views/community/content/index');
    },
    meta: {
      title: '社区内容',
      icon: 'clipboard'
    }
  }, {
    path: 'comments',
    name: 'communityComments',
    component: function component() {
      return import('@/views/community/comments/index');
    },
    meta: {
      title: '社区评论',
      icon: 'clipboard'
    }
  }, {
    path: 'config',
    name: 'communityConfig',
    component: function component() {
      return import('@/views/community/config/index');
    },
    meta: {
      title: '社区配置',
      icon: 'clipboard'
    }
  }, {
    path: 'industryNews',
    name: 'communityIndustryNews',
    component: function component() {
      return import('@/views/community/industryNews/index');
    },
    meta: {
      title: '行业资讯',
      icon: 'document'
    }
  }, {
    path: 'industryNewsCategories',
    name: 'communityIndustryNewsCategories',
    component: function component() {
      return import('@/views/community/industryNews/categories');
    },
    meta: {
      title: '资讯分类',
      icon: 'document'
    }
  }, {
    path: 'industryNewsComments',
    name: 'communityIndustryNewsComments',
    component: function component() {
      return import('@/views/community/industryNews/comments');
    },
    meta: {
      title: '资讯评论',
      icon: 'document'
    }
  }]
};
export default communityRouter;